import { Skeleton } from "@mantine/core";
import { type CSSProperties, useEffect, useState } from "react";

import { authFetch } from "../api/client";

/** Slika iz API-ja koja zahtijeva token (fotografije stabala nisu javne). Vraća object URL ili null. */
export function useAuthBlobUrl(path: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!path) { setUrl(null); return; }
    let alive = true;
    let obj: string | null = null;
    authFetch(path).then(async (r) => {
      if (!r.ok || !alive) return;
      obj = URL.createObjectURL(await r.blob());
      if (alive) setUrl(obj);
    }).catch(() => undefined);
    return () => { alive = false; if (obj) URL.revokeObjectURL(obj); };
  }, [path]);
  return url;
}

export function AuthImage({ path, alt, style, h }: { path: string; alt: string; style?: CSSProperties; h?: number }) {
  const url = useAuthBlobUrl(path);
  if (!url) return <Skeleton h={h ?? 120} />;
  return <img src={url} alt={alt} style={{ display: "block", width: "100%", objectFit: "cover", ...(h ? { height: h } : {}), ...style }} />;
}
